import { createFileRoute } from "@tanstack/react-router";

import { CustomersPage } from "@/components/Pages/Customers";

export const Route = createFileRoute("/_guard/customers/")({
  component: CustomersPage,
});
